export const preferredCountryCode = ['+65', '+62', '+60', '+84'];
